export default __webpack_public_path__ + "images/SpeakersPhotos/Eduardo Canelles_Digital Tatics.jpg?37979ae1";